<!-- 500 Server internal error页面 -->
<template>
    <div class="admin-error">
        <el-row class="admin-error-content">
            <el-col :span="14">
                <svg class="error-img">
                    <use xlink:href="#500"></use>
                </svg>
            </el-col>
            <el-col :span="10">
                <h5 class="error-code">500</h5>
                <p class="error-message">抱歉，服务器内部出现错误</p>
                <div>
                    <el-button type="primary" @click="goToIndex()">返回首页</el-button>
                </div>
            </el-col>
        </el-row>
    </div>
</template>

<script>
import '@/assets/svg/500.svg';
import './error.scss';

export default {
    name: 'ServerInternalError',

    data() {
        return {};
    },

    methods: {
        goToIndex() {
            this.$router.push({
                name: 'Forward',
                params: {
                    target: 'Index'
                }
            });
        }
    }
};
</script>
<style lang='scss'>
</style>